module.exports = __webpack_public_path__ + "f91cc3b863fdc009541a27b63b89f21c.ttf";